import SectionCard from "../ui/SectionCard";
import RiskProfiler from "../ui/RiskProfiler";
import { ClipboardCheckIcon } from "../ui/icons";
import { StepViewProps } from "./types";

export default function RiskStep({ state, handlers }: StepViewProps) {
  return (
    <SectionCard title="Risk profiler" icon={<ClipboardCheckIcon size={18} />}>
      <RiskProfiler
        questionnaire={state.draft.riskQuestionnaire}
        result={state.risk.result}
        error={state.errors.riskQuestionnaire}
        onAnswer={handlers.answerRisk}
      />
    </SectionCard>
  );
}
